<template>
  <div class="buttonlist">
    <div class="buttonlist-m">
      <el-form :inline="true" class="toolbar" @submit.native.prevent>
        <el-form-item label="组名称">
          <el-input v-model.trim="searchName" placeholder="护理组名称" clearable style="width:180px" @keyup.enter.native="loadData" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain icon="el-icon-search" :loading="loading" @click="loadData">查询</el-button>
          <el-button v-if="canChange" type="success" plain icon="el-icon-plus" @click="goAdd">新增护理组</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="loading" :data="tableData" :row-style="tableRowStyle" :header-cell-style="tableHeaderColor">
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column label="组名称" prop="name" align="center" min-width="120" />
        <el-table-column label="组长" prop="realName" align="center" width="100">
          <template slot-scope="s">{{ s.row.realName || "未设置" }}</template>
        </el-table-column>
        <el-table-column label="成员数" align="center" width="90">
          <template slot-scope="s">{{ s.row.memberCount != null ? s.row.memberCount : "-" }}</template>
        </el-table-column>
        <el-table-column v-if="canChange" label="操作" align="center" width="280" fixed="right">
          <template slot-scope="s">
            <el-button type="warning" size="mini" plain @click="openRename(s.row)">改名</el-button>
            <el-button type="primary" size="mini" plain @click="openMembers(s.row)">成员</el-button>
            <el-button type="danger" size="mini" plain @click="handleDelete(s.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog title="修改组名称" :visible.sync="renameVisible" width="420px" append-to-body>
      <el-input v-model.trim="renameName" placeholder="组名称" />
      <div slot="footer">
        <el-button @click="renameVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="submitRename">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="(currentGroup ? currentGroup.name : '') + ' · 成员管理'" :visible.sync="membersVisible" width="560px" append-to-body>
      <div style="display:flex;margin-bottom:14px">
        <el-select v-model="addMemberIds" multiple filterable placeholder="添加护工" style="flex:1">
          <el-option v-for="s in availableStaff" :key="s.userId" :value="s.userId" :label="s.realName || s.userName" />
        </el-select>
        <el-button type="primary" :loading="addingMember" :disabled="!addMemberIds.length" style="margin-left:8px" @click="handleAddMembers">添加</el-button>
      </div>
      <el-table :data="currentMembers" size="small" stripe>
        <el-table-column label="姓名" prop="realName" align="center" />
        <el-table-column label="角色" width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="isLeader(row)" type="primary" size="mini">组长</el-tag>
            <span v-else>护理员</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160" align="center">
          <template slot-scope="{ row }">
            <el-button v-if="!isLeader(row)" type="text" size="mini" @click="handleSetLeader(row)">设为组长</el-button>
            <el-popconfirm title="移出该护工？" @confirm="handleRemoveMember(row)">
              <el-button slot="reference" type="text" size="mini" :disabled="isLeader(row)">移出</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus";
import {
  getNursingGroupList,
  getNursingGroupMembers,
  updateNursingGroupName,
  deleteNursingGroup,
  addNursingGroupMembers,
  removeNursingMember,
  updateNursingGroupLeader,
  getAllNursingStaff
} from "@/views/care/schedule/scheduleApi";

export default {
  name: "NursingCareGroupList",
  data() {
    return {
      searchName: "",
      tableData: [],
      loading: false,
      allStaff: [],
      renameVisible: false,
      renameName: "",
      editingGroup: null,
      submitting: false,
      membersVisible: false,
      currentGroup: null,
      currentMembers: [],
      addMemberIds: [],
      addingMember: false
    };
  },
  computed: {
    canChange() {
      return this.$route.path === "/CareNursingGroupChange";
    },
    availableStaff() {
      const exist = new Set(this.currentMembers.map(m => String(m.nursingUserId || m.userId)));
      return this.allStaff.filter(s => !exist.has(String(s.userId)));
    }
  },
  mounted() {
    getAllNursingStaff().then(res => {
      if (res && res.code == 200) {
        const data = res.result || res;
        this.allStaff = Array.isArray(data) ? data : (data.list || data.records || []);
      }
    });
    this.loadData();
  },
  methods: {
    tableRowStyle() {
      return { height: "48px" };
    },
    tableHeaderColor() {
      return { background: "#eef1f6", color: "#606266", fontWeight: "600" };
    },
    goAdd() {
      bus.$emit("homePage", { type: "jump", path: "/CareNursingGroupAdd", title: "护理组增加" });
    },
    loadData() {
      this.loading = true;
      getNursingGroupList(this.searchName || undefined).then(async res => {
        if (res && res.code == 200) {
          const data = res.result || res;
          const list = Array.isArray(data) ? data : (data.list || data.records || []);
          for (const g of list) {
            try {
              const mRes = await getNursingGroupMembers(g.id);
              if (mRes && mRes.code == 200) {
                const mData = mRes.result || mRes;
                const members = mData.list || mData.data || (Array.isArray(mData) ? mData : []);
                g.memberCount = members.length;
              } else g.memberCount = 0;
            } catch {
              g.memberCount = 0;
            }
          }
          this.tableData = list;
        }
        this.loading = false;
      }).catch(() => { this.loading = false; });
    },
    openRename(row) {
      this.editingGroup = row;
      this.renameName = row.name;
      this.renameVisible = true;
    },
    submitRename() {
      if (!this.renameName.trim()) {
        this.$message.warning("请输入组名称");
        return;
      }
      this.submitting = true;
      updateNursingGroupName({ nursingGroupId: this.editingGroup.id, name: this.renameName }).then(res => {
        this.submitting = false;
        if (res && res.code == 200) {
          this.$message.success("修改成功");
          this.renameVisible = false;
          this.loadData();
        }
      }).catch(() => { this.submitting = false; });
    },
    handleDelete(row) {
      this.$confirm(`确认删除护理组「${row.name}」？`, "提示", { type: "warning" }).then(() => {
        deleteNursingGroup(row.id).then(res => {
          if (res && res.code == 200) {
            this.$message.success("已删除");
            this.loadData();
          }
        });
      }).catch(() => {});
    },
    async openMembers(g) {
      this.currentGroup = g;
      this.addMemberIds = [];
      this.membersVisible = true;
      await this.refreshMembers();
    },
    async refreshMembers() {
      if (!this.currentGroup) return;
      const res = await getNursingGroupMembers(this.currentGroup.id);
      if (res && res.code == 200) {
        const data = res.result || res;
        this.currentMembers = data.list || data.data || (Array.isArray(data) ? data : []);
      }
    },
    isLeader(m) {
      return this.currentGroup && String(m.nursingUserId || m.userId) === String(this.currentGroup.userId);
    },
    handleAddMembers() {
      this.addingMember = true;
      addNursingGroupMembers({
        nursingGroupId: this.currentGroup.id,
        userList: this.addMemberIds.map(id => ({ userid: id }))
      }).then(res => {
        this.addingMember = false;
        if (res && res.code == 200) {
          this.$message.success("添加成功");
          this.addMemberIds = [];
          this.refreshMembers();
          this.loadData();
        }
      }).catch(() => { this.addingMember = false; });
    },
    async handleRemoveMember(m) {
      const res = await removeNursingMember(m.nursingUserId || m.userId);
      if (res && res.code == 200) {
        this.$message.success("已移出");
        this.refreshMembers();
        this.loadData();
      }
    },
    async handleSetLeader(m) {
      const uid = m.nursingUserId || m.userId;
      const res = await updateNursingGroupLeader({ nursingGroupId: this.currentGroup.id, userId: uid });
      if (res && res.code == 200) {
        this.currentGroup = { ...this.currentGroup, userId: uid };
        this.$message.success("已设为组长");
        this.refreshMembers();
        this.loadData();
      }
    }
  }
};
</script>
